<nav *ngIf="menuItems.length" class="navegacao-breadcrumb">
  <a class="rotas" [href]="pagina.url" *ngFor="let pagina of menuItems">{{pagina.label}}</a>
</nav>